const DEFAULT_API_ORIGIN = 'https://auth.nidoportal.com';
const configuredUrl = process.env.NODE_ENV === 'development'
  ? ''
  : process.env.REACT_APP_API_URL?.trim();

// Vercel estuvo configurado históricamente con una URL terminada en `/api`,
// mientras que el cliente añade ese prefijo de forma centralizada. Aceptamos
// ambas variantes para evitar solicitudes accidentales a `/api/api/...`.
// En desarrollo usamos /api sobre localhost. CRA lo redirige al backend y la
// cookie queda en el mismo sitio, algo imprescindible en Safari/ventanas privadas.
// Producción continúa usando auth.nidoportal.com.
export const API_ORIGIN = process.env.NODE_ENV === 'development' ? '' : (configuredUrl || DEFAULT_API_ORIGIN)
  .replace(/\/+$/, '')
  .replace(/\/api$/i, '');
export const API_BASE_URL = `${API_ORIGIN}/api`;

export function apiUrl(path = '') {
  const normalizedPath = path.startsWith('/') ? path : `/${path}`;

  return normalizedPath === '/api' || normalizedPath.startsWith('/api/')
    ? `${API_ORIGIN}${normalizedPath}`
    : `${API_BASE_URL}${normalizedPath}`;
}
